import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { isPathEk } from '@/utils/routes';
import MyAccountEk from './MyAccountEk';
import MyAccountGas from './MyAccountGas';

export default observer(function MyAccountTab() {
    // hook
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    return <>{isEk ? <MyAccountEk /> : <MyAccountGas />}</>;
});
